@use "../../../../../styles/Colors.scss" as Colors;
@use "../../../../../styles/Constants.scss" as Constants;

.signature-modal {

	&__tabs {
		display: flex;
		justify-content: center;
		margin-top: Constants.$val-spacing-xxxl;
		margin-bottom: Constants.$val-spacing-l;
	}

	&__tab {
		font-size: Constants.$val-fontSizeRegular;
		background-color: Colors.$col-greyBackground;
		padding: Constants.$val-spacing-s Constants.$val-spacing-xl;
		font-weight: bold;
		cursor: pointer;

		&:first-child {
			border-radius: Constants.$val-spacing-xs 0px 0px Constants.$val-spacing-xs;
		}

		&:last-child {
			border-radius: 0px Constants.$val-spacing-xs Constants.$val-spacing-xs 0px;
		}

		&--active {
			color: Colors.$col-white;
			background-color: Colors.$col-darkBlueBorder;
		}
	}
}